import React from 'react';
import { sponsors } from '../mock';

const Sponsors = () => {
  const loop = [...sponsors, ...sponsors];
  return (
    <section id="partners" className="py-16 bg-white border-t border-black/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-10">
          <span className="text-neutral-500 text-xs font-semibold uppercase tracking-[0.25em]">
            Trusted by community & funding partners
          </span>
        </div>
        <div className="relative overflow-hidden">
          <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10" />
          <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10" />
          <div className="flex gap-14 animate-marquee whitespace-nowrap items-center">
            {loop.map((s, i) => (
              <div
                key={i}
                className="font-serif text-2xl font-semibold text-neutral-400 hover:text-[#6e12ed] transition-colors whitespace-nowrap"
              >
                {s.name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sponsors;
